<div class="guest-panel">
  <div *ngFor="let guest of this.guestList">
    <img matTooltip="{{guest.username}}" class="avatar-icon" src="{{this.getAvatarTemplateUrl(guest.avatarTemplate)}}" alt="avatarImage">
  </div>
</div>
